<style lang="scss">
  .top-spacer {
    padding-top: 64px;

    @include breakpoint(md) {
      padding-top: 84px;
    }
    @include breakpoint(lg) {
      padding-top: 114px;
    }
  }
</style>

<div class="top-spacer" />
